"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _ButtonText = _interopRequireDefault(require("@commerce-ui/core2/ButtonText"));
var _Spinner = _interopRequireDefault(require("@commerce-ui/core2/Spinner"));
var _core = require("@commerce-ui/core2");
var __jsx = _react["default"].createElement;
var heights = {
  extraSmall: "32px",
  small: "36px",
  standard: "48px",
  large: "58px"
};
var _default = (0, _core.createComponent)(_ButtonText["default"], function (_ref) {
  var _ref$$size = _ref.$size,
    $size = _ref$$size === void 0 ? "standard" : _ref$$size,
    _ref$$outline = _ref.$outline,
    $outline = _ref$$outline === void 0 ? false : _ref$$outline,
    _ref$$color = _ref.$color,
    $color = _ref$$color === void 0 ? "main" : _ref$$color,
    _ref$$colorFont = _ref.$colorFont,
    $colorFont = _ref$$colorFont === void 0 ? false : _ref$$colorFont,
    _ref$$selectable = _ref.$selectable,
    $selectable = _ref$$selectable === void 0 ? false : _ref$$selectable,
    _ref$$rounded = _ref.$rounded,
    $rounded = _ref$$rounded === void 0 ? false : _ref$$rounded,
    _ref$$secondFont = _ref.$secondFont,
    $secondFont = _ref$$secondFont === void 0 ? false : _ref$$secondFont,
    _ref$$forceSquare = _ref.$forceSquare,
    $forceSquare = _ref$$forceSquare === void 0 ? false : _ref$$forceSquare,
    _ref$$borderMainColor = _ref.$borderMainColor,
    $borderMainColor = _ref$$borderMainColor === void 0 ? "neutral" : _ref$$borderMainColor,
    _ref$$switchBg = _ref.$switchBg,
    $switchBg = _ref$$switchBg === void 0 ? false : _ref$$switchBg,
    _ref$$extraRound = _ref.$extraRound,
    $extraRound = _ref$$extraRound === void 0 ? false : _ref$$extraRound,
    _ref$$extraColor = _ref.$extraColor,
    $extraColor = _ref$$extraColor === void 0 ? "" : _ref$$extraColor,
    _ref$$gradientBg = _ref.$gradientBg,
    $gradientBg = _ref$$gradientBg === void 0 ? false : _ref$$gradientBg,
    _ref$$gradientBaseCol = _ref.$gradientBaseColor,
    $gradientBaseColor = _ref$$gradientBaseCol === void 0 ? "" : _ref$$gradientBaseCol,
    _ref$$gradientEndColo = _ref.$gradientEndColor,
    $gradientEndColor = _ref$$gradientEndColo === void 0 ? "#323232" : _ref$$gradientEndColo,
    _ref$$iconButton = _ref.$iconButton,
    $iconButton = _ref$$iconButton === void 0 ? false : _ref$$iconButton;
  return function (_ref2) {
    var disabled = _ref2.disabled,
      selected = _ref2.selected;
    return {
      height: $iconButton ? "40px" : heights[$size],
      minWidth: $iconButton ? "40px" : $rounded ? "auto" : "158px",
      width: $iconButton ? "40px" : "auto",
      borderRadius: $forceSquare ? "0" : $extraRound ? "30px" : $rounded ? "5px" : "2px",
      overflow: "hidden",
      ":focus": {
        outline: 0,
        boxShadow: "none"
      },
      "::-moz-focus-inner": {
        border: 0
      },
      borderColor: disabled ? $borderMainColor : selected && $rounded ? $borderMainColor : !$selectable || selected ? "gradientEnd" : $borderMainColor,
      borderStyle: "solid",
      borderWidth: $outline ? "1px" : 0,
      $background: {
        bg: $switchBg ? $extraColor ? $extraColor : "main" : disabled && !$outline ? "neutral" : selected && $rounded ? "neutral" : $outline ? $extraRound ? "none" : "white" : $color,
        backgroundImage: $gradientBg ? "linear-gradient(to right, ".concat($gradientBaseColor, ", ").concat($gradientEndColor, ")") : "none",
        transition: "all .15s"
      },
      $body: {
        color: $switchBg ? "white" : $colorFont ? $colorFont : disabled ? "neutral700" : $outline ? $color : "white",
        font: $secondFont ? "s_caps" : "xs_caps" /** WAŻNE!!! Nie dodawajmy tutaj żadnych marginesów / paddingów zeby wyrównać font. Ten font jest niepoprawnie zakodownay, trzeba coś z tym zrobić inaczej **/,
        px: $iconButton ? 0 : 12,
        transition: "color .15s"
      },
      $gap: "8px",
      $iconSize: 24,
      $loader: {
        __children: __jsx(_Spinner["default"], {
          sx: {
            $color: disabled && $outline ? "neutral" : disabled && !$outline ? "neutral900" : $outline ? $color : "white",
            $color2: "rgba(255,255,255,0.2)"
          }
        })
      }
    };
  };
});
exports["default"] = _default;